import React, { useEffect, useState, useRef } from 'react';
import { SparklesIcon, BugIcon, MessageSquareIcon, HelpCircleIcon, ShieldIcon, FileTextIcon, MailIcon, PlayCircleIcon } from 'lucide-react';
import FeedbackModal from './FeedbackModal';
interface SupportDropdownProps {
  trigger: React.ReactNode;
  onStartVideoTour?: () => void;
}
const SupportDropdown: React.FC<SupportDropdownProps> = ({
  trigger,
  onStartVideoTour
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<'feature' | 'bug' | 'feedback' | 'support' | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleModalOpen = (type: 'feature' | 'bug' | 'feedback' | 'support') => {
    setModalType(type);
    setIsOpen(false);
  };
  const menuItems = [{
    label: 'Video Tutorial',
    icon: PlayCircleIcon,
    action: () => {
      if (onStartVideoTour) {
        onStartVideoTour();
      }
    },
    description: 'Watch how it works'
  }, {
    type: 'divider'
  }, {
    label: 'Feature Request',
    icon: SparklesIcon,
    action: () => handleModalOpen('feature'),
    description: 'Suggest new features'
  }, {
    label: 'Report Bug',
    icon: BugIcon,
    action: () => handleModalOpen('bug'),
    description: 'Found an issue?'
  }, {
    label: 'Give Feedback',
    icon: MessageSquareIcon,
    action: () => handleModalOpen('feedback'),
    description: 'Share your thoughts'
  }, {
    type: 'divider'
  }, {
    label: 'Help Center',
    icon: HelpCircleIcon,
    action: () => {
      window.open('https://help.ainstein.com', '_blank');
    },
    description: 'Documentation & FAQs'
  }, {
    label: 'Contact Support',
    icon: MailIcon,
    action: () => handleModalOpen('support'),
    description: 'Get in touch'
  }, {
    type: 'divider'
  }, {
    label: 'Privacy Policy',
    icon: ShieldIcon,
    action: () => {
      window.open('https://ainstein.com/privacy', '_blank');
    }
  }, {
    label: 'Terms of Service',
    icon: FileTextIcon,
    action: () => {
      window.open('https://ainstein.com/terms', '_blank');
    }
  }];
  return <>
      <div className="relative" ref={dropdownRef} data-id="element-2395">
        <div onClick={() => setIsOpen(!isOpen)} data-id="element-2396">{trigger}</div>
        {isOpen && <div className="absolute right-0 mt-2 w-72 bg-surface-elevated rounded-xl shadow-custom-lg py-2 z-20 border border-custom" data-id="element-2397">
            {menuItems.map((item, index) => {
          if (item.type === 'divider') {
            return <div key={`divider-${index}`} className="my-2 border-t border-custom" data-id="element-2398" />;
          }
          const Icon = item.icon;
          return <button key={index} className="w-full flex items-start gap-3 px-4 py-2.5 text-sm text-text-primary hover:bg-surface transition-colors group" onClick={() => {
            item.action();
            setIsOpen(false);
          }} data-id="element-2399">
                  <div className="mt-0.5" data-id="element-2400">
                    <Icon size={18} className="text-text-secondary group-hover:text-[#00B75F] transition-colors" data-id="element-2401" />
                  </div>
                  <div className="flex-1 text-left" data-id="element-2402">
                    <div className="font-medium" data-id="element-2403">{item.label}</div>
                    {item.description && <div className="text-xs text-text-tertiary mt-0.5" data-id="element-2404">
                        {item.description}
                      </div>}
                  </div>
                </button>;
        })}
          </div>}
      </div>
      {/* Feedback Modal */}
      {modalType && <FeedbackModal isOpen={!!modalType} onClose={() => setModalType(null)} type={modalType} data-id="element-2405" />}
    </>;
};
export default SupportDropdown;